/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC } from 'react'
import { useLang, setLanguage } from '../../../i18n/Metronici18n'
import useTranslate from '../../../../app/hooks/useTranslate'

const languages = [
  { lang: 'en', name: 'English' },
  { lang: 'ro', name: 'Romanian' },
]

const Languages: FC = () => {


  const lang = useLang()
  const t= useTranslate();

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(event.target.value)
  }

  return (
    <div className="d-flex align-items-center px-5">
      <select 
        className="form-select w-auto" 
        value={lang} 
        onChange={handleLanguageChange}
      >
        {languages.map((l) => (
          <option key={l.lang} value={l.lang}>
            {l.name} 
          </option>
        ))}
      </select>
    </div>
  )
}

export { Languages }

